
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { GetTrip, Trip, TripMutation } from '@clients/myTrips';
import TripDetailTabData from '@components/trip-detail/trip-tabs/TripDetailTabData.vue';
import TripDetailTabChanges from '@components/trip-detail/trip-tabs/TripDetailTabChanges.vue';
import TripDetailTabDetails from '@components/trip-detail/trip-tabs/TripDetailTabDetails.vue';
import NewestTripIcon from '@components/icons/icon-newest-trip.svg';
import OldestTripIcon from '@components/icons/icon-oldest-trip.svg';

export type Tab = 'data' | 'details' | 'changes';

export type AddType = 'last' | 'first' | 'gap';

@Component({
  name: 'TripDetailTabs',
  components: {
    TripDetailTabDetails,
    TripDetailTabChanges,
    TripDetailTabData,
    NewestTripIcon,
    OldestTripIcon
  }
})
export default class TripDetailTabs extends Vue {
  $refs!: {
    tripDetailData: TripDetailTabData
  }

  @Prop()
  private trip: GetTrip;

  @Prop()
  private tripMutation: TripMutation;

  @Prop({ default: false })
  private editMode: boolean;

  @Prop({ default: false })
  private addMode: boolean;

  @Prop({ default: false })
  private isGapFill: boolean;

  @Prop({ default: false })
  private oldestTripDisabled: boolean;

  @Prop({ default: false })
  private newestTripDisabled: boolean;

  @Prop()
  private prevTrip: Trip;

  @Prop()
  private nextTrip: Trip;

  @Prop({ default: false })
  private loading: boolean;

  private activeTab: Tab = 'data';

  private activeAddType: AddType = 'last';

  get singleButtonText() {
    return this.isGapFill ? 'Lücke im Fahrtenbuch füllen' : 'Erste Fahrt erstellen';
  }

  get isFirstTrip() {
    return this.addMode && !this.prevTrip && !this.nextTrip;
  }

  private clickTab(tab: Tab) {
    this.activeTab = tab;
  }

  private clickAddType(type: AddType) {
    if (!this.oldestTripDisabled && !this.newestTripDisabled) {
      this.activeAddType = type;
      this.$emit('addType', type);
    }
  }

  private handleInput(copy: TripMutation) {
    this.$emit('input', copy);
  }

  private emitEdit() {
    this.$emit('toggleEditMode');
  }

  private handleSave() {
    this.$emit('save');
  }
}
